// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2793 ? "katex" : chunkId) + "." + {"2793":"e3971de8","9996":"232fffff"}[chunkId] + ".chunk.css";
};